module.exports = __webpack_public_path__ + "media/images/application/favicon/safari-pinned-tab-3b8dad91163470f4ebd688615bbb60cb.svg";